import { AxiosResponse } from 'axios'
import { http } from '@/services/http.service'
import { IAccount } from '@/types/general'

export const create = (account: IAccount): Promise<AxiosResponse> => {
  return http.post('/api/accounts', { account })
}

export const fetchAll = (): Promise<AxiosResponse> => {
  return http.get('/api/accounts')
}

export const fetchAllForUser = (userId): Promise<AxiosResponse> => {
  return http.get(`/api/accounts?user_id=${userId}`)
}

export const fetchBySubdomain = (subdomain): Promise<AxiosResponse> => {
  return http.get(`/api/accounts/find_by_subdomain?subdomain=${subdomain}`)
}

export const fetch = (id): Promise<AxiosResponse> => {
  return http.get(`/api/accounts/${id}`)
}

export const sendUSSSARosters = (id): Promise<AxiosResponse> => {
  return http.post('/api/accounts/send_USSSA_Rosters', { id })
}
